import React from "react";
import { useTranslation } from "react-i18next";
import { Menu } from "./components/menu/Menu";

export const Navigation: React.FC = () => {
  const { t } = useTranslation("footer");

  const menus = [
    {
      title: t("menu_1_title"),
      items: [
        { label: t("banking"), link: "/bank" },
        { label: t("saving"), link: "/bank/savings-account" },
        { label: t("investing"), link: "/investment" },
        { label: "Apple Pay", link: "/bank/apple-pay" },
        { label: "Google Pay", link: "/bank/google-pay" },
        { label: t("pricing"), link: "/pricing" },
      ],
    },
    {
      title: t("menu_2_title"),
      items: [
        { label: t("refer_a_friend"), link: "/refer-a-friend" },
        { label: t("fees_simulator"), link: "/investment/cost-calculator" },
        { label: t("currency_converter"), link: "/bank/currency-converter/" },
        { label: t("financialreport"), link: "/financial-reports" },
        { label: t("philosophy"), link: "/investment/our-philosophy" },
        { label: t("blog"), link: "/blog" },
      ],
    },
    {
      title: t("menu_3_title"),
      items: [
        { label: t("about_us"), link: "/about-us" },
        { label: t("events"), link: "/events" },
        { label: t("ambassadors"), link: "/alpian-ambassadors" },
        { label: t("careers"), link: "/careers" },
      ],
    },
    {
      title: t("menu_4_title"),
      items: [
        { label: t("lost_cards"), link: "/lost-card" },
        { label: t("contact"), link: "/contact" },
        { label: t("faq"), link: "/faq" },
      ],
    },
  ];

  return (
    <>
      {menus.map((menu) => (
        <div key={menu.title}>
          <Menu title={menu.title} items={menu.items} />
        </div>
      ))}
    </>
  );
};
